import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getClassifications = async ({ commit }) => {
  commit('setClassificationIsLoading', true);
  let url = `/classifications/selectable`;

  await connection.get(url)
    .then(res => {
      const classifications = res.data.data;
      commit('setClassificationsSelectable', classifications);
      commit('setClassificationIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClassificationIsLoading', false);
    });
}

export const loadClassifications = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setClassificationIsLoading', true);
    let url = `/classifications`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const classifications = res.data.data;
        commit('setClassifications', classifications);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setClassificationsPaginated', res.data);
        commit('setClassificationIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setClassificationIsLoading', false);
      });
}

export const classificationById = async ({ commit }, id) => {
  commit('setClassificationIsLoading', true);
  await connection.get(`/classifications/${id}`)
    .then(res => {
      commit('setClassificationDetail', res.data.data);
      commit('setClassificationIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClassificationIsLoading', false);
    });
}

export const storeClassification = async ({ commit }, classification) => {
  commit('setClassificationIsCreating', true);
  await connection.post(`/classifications/create`, classification)
    .then(res => {
      commit('saveNewClassifications', res.data.data);
      commit('setClassificationIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClassificationIsCreating', false);
    });
}

export const updateClassification = async ({ commit }, classification ) => {
  commit('setClassificationIsUpdating', true);
  await connection.put(`/classifications/${classification.id}/update`, classification)
    .then(res => {
      commit('saveUpdatedClassification', res.data.data);
      commit('setClassificationIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClassificationIsUpdating', false);
    });
}

export const deleteClassification = async ({ commit }, classification) => {
  commit('setClassificationIsDeleting', true);
  await connection.delete(`/classifications/${classification.id}/delete`)
    .then(res => {
      console.log(res);
      commit('setDeleteClassification', res.data.data);
      commit('setClassificationIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setClassificationIsDeleting', false);
    });
}
